export const buildUrl = (base, rel) => {
  if (!rel) return '';
  const cleanBase = base.replace(/\/$/, '');
  const cleanRel  = rel.replace(/\\/g, '/').replace(/^\/?/, '');
  return `${cleanBase}/${cleanRel}`; // http://localhost:5000/uploads/...
};
